module.exports = __webpack_public_path__ + "img/Posada-cabo_0002_hotel4.8af9770b.jpg";